import { CACHE_BOSS } from "../../utils/storage/constant";
import { CacheModule } from "../cacheModule";

class CacheBossPath extends CacheModule {
    constructor() {
        super(CACHE_BOSS, null);
    }
}
export default new CacheBossPath();
